import { lazyLoad } from 'utils/loadable';

export const Calls = lazyLoad(
  () => import('./index'),
  module => module.Calls,
);
